import {baseMethods, ResultType, ResultTypesEnum, StringResult, TeammateResult, UrlResult} from './internal';

export const topicType: ResultType = {
  name: ResultTypesEnum.TOPIC,
  properties: {
    id: StringResult,
    name: StringResult,
    url: UrlResult,
    description: StringResult,
    status: StringResult,
    owner: TeammateResult,
  },
  methods: {
    ...baseMethods,
  },
};
